import type { ImportRowLog } from "@/project/karuna/utils/schoolImportRowEngine";

export function getSchoolDisplayName(log: ImportRowLog): string {
  const name = String(
    log.mapped_values.schoolname ?? log.mapped_values.school_name ?? ""
  ).trim();
  const principal = String(log.mapped_values.principal ?? "").trim();

  if (name && principal) {
    return `${name} / ${principal}`;
  }
  return name || principal || `Row ${log.row_number}`;
}

export function formatImportLogAction(log: ImportRowLog): string {
  if (log.status === "FAILED") {
    return "—";
  }
  return log.action === "updated" ? "Updated" : "Created";
}

export function formatImportLogStatus(log: ImportRowLog): string {
  return log.status === "FAILED" ? "Failed" : "Success";
}

export function formatImportLogMessage(log: ImportRowLog): string {
  const schoolLabel = getSchoolDisplayName(log);

  if (log.status === "FAILED") {
    const trimmedReason = log.error_message?.trim();
    const reason = trimmedReason?.length
      ? trimmedReason
      : "Could not import this row.";
    return `${reason}\n${schoolLabel}`;
  }

  const actionLabel =
    log.action === "updated" ? "Updated existing record" : "Created new record";
  const idPart = log.record_id ? ` (${log.record_id})` : "";

  return `${actionLabel}${idPart}\n${schoolLabel}`;
}

export interface ImportLogSheetRow {
  "Row Number": number;
  Action: string;
  Status: string;
  Message: string;
}

export function buildImportLogSheetRows(
  logs: ImportRowLog[]
): ImportLogSheetRow[] {
  return logs.map(log => ({
    "Row Number": log.row_number,
    Action: formatImportLogAction(log),
    Status: formatImportLogStatus(log),
    Message: formatImportLogMessage(log),
  }));
}
